import { Button, Drawer, Popconfirm } from "antd"
import ButtonCustom from "../../ButtonCustom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faArrowRightLong, faXmark } from "@fortawesome/free-solid-svg-icons";
import { BodyDrawer, CloseTopDrawer, FooterDrawer, HeaderDrawer } from "./style";
import { TitleH1 } from "../titleH1";
import { Render } from "../render";
import { ConfirmarFecharGaveta } from "../../../Views/app/patrimonioNovo/components/confirmarFecharGaveta";
import { useState } from "react";
import { Inline } from "../inline";

//interface
interface Props {
    open: boolean;
    onClose: Function;
    children?: React.ReactNode;
    childrenFooter?: React.ReactNode;
    destroyOnClose?: boolean;
    width?: number | string;
    closeButtonLabel?: 'Fechar' | 'Voltar';
    title?: string;
    actions?: React.ReactNode;
    paddingBody?: number;
    extraHeader?: React.ReactNode;
    confirmOnClose?: boolean;
    setConfirmOnClose?: React.Dispatch<React.SetStateAction<boolean>>;
}

export const DrawerCustom: React.FC<Props> = ({ open, onClose, children, width, closeButtonLabel = 'Fechar', 
    title, actions, paddingBody, childrenFooter, extraHeader, confirmOnClose, setConfirmOnClose
 }) => {

    //STATES
    const [open_confirm, setOpen_confirm] = useState<boolean>(false);

    return (
        <Drawer
            open={open}
            onClose={()=>{onClose()}}
            destroyOnClose
            headerStyle={{display:'none'}}
            footer={false}
            width={width ?? 500}
            bodyStyle={{padding: 0, overflow: 'hidden'}}
        >
            
            <CloseTopDrawer>
                

                <Popconfirm
                    placement='left'
                    title={title}
                    open={open_confirm}
                    description={
                        <div style={{ display: 'flex', flexDirection: 'column', gap: 15 }}>
                            <span>
                                {'message'}
                            </span>
                            <Inline justifyContent='flex-end'>
                                <ButtonCustom
                                    onClick={onClose}
                                    icon={<FontAwesomeIcon icon={faXmark} />}
                                    danger
                                    type='tertiary'
                                >
                                    Fechar
                                </ButtonCustom>

                                <ButtonCustom
                                    onClick={() => {
                                        setOpen_confirm(false)
                                    }}
                                    // type="tertiary"
                                    icon={<FontAwesomeIcon icon={faArrowRightLong} />}
                                >
                                    Voltar para o cadastro
                                </ButtonCustom>
                            </Inline>
                        </div>
                    }
                    okButtonProps={{ style: { display: 'none' } }}
                    cancelButtonProps={{ style: { display: 'none' } }}
                >
                    <Button style={{background:'transparent', padding:0, margin:0, border:'none', boxShadow:'none',all:'unset'}}>
                        <ButtonCustom 
                            // onClick={()=>{setOpen_confirm(true)}}
                            onClick={()=>{onClose()}}
                            type="tertiary"
                            icon={<FontAwesomeIcon  icon={closeButtonLabel==='Fechar' ? faXmark : faAngleLeft} />}
                            danger
                        >
                            Fechar
                        </ButtonCustom>
                    </Button>
                </Popconfirm>

                {actions}
            </CloseTopDrawer>

            <Render condition={!!title}>
                <HeaderDrawer>
                    <TitleH1>{title}</TitleH1>
                    {extraHeader}
                </HeaderDrawer>
            </Render>
            
            <BodyDrawer style={{padding: paddingBody}}>
                {children}
            </BodyDrawer>
            
            {childrenFooter &&(
                <FooterDrawer style={{padding: paddingBody}}>
                    {childrenFooter}
                </FooterDrawer>
            )}


        </Drawer>
    )
}